module.exports = __webpack_public_path__ + "img/bjr.3ea93423.png";